if (!customElements.get('main-search')) {
    customElements.define('main-search', class MainSearch extends SearchForm {
        allSearchInputs;
        searchAbortController;
        searchResultsWrapper;
        searchForm;
        lastProductCount = 0;
        lastArticleCount = 0;
        constructor() {
            super();
            this.allSearchInputs = document.querySelectorAll('input[type="search"]');
            this.setupEventListeners();
            this.searchAbortController = new AbortController();
            this.searchResultsWrapper = document.querySelector('.template-search__results-wrapper');
            this.searchForm = this.querySelector('form.search');
            // Initialize counts from existing labels if they exist
            this.lastProductCount = this.extractCountFromLabel('label[for="products"]');
            this.lastArticleCount = this.extractCountFromLabel('label[for="articles"]');
            this.fetchResultsCount();
            this.setupTabEventListeners();
        }
        setupEventListeners() {
            let allSearchForms = [];
            this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
            this.input?.addEventListener('focus', this.onInputFocus.bind(this));
            if (allSearchForms.length < 2)
                return;
            allSearchForms.forEach((form) => form?.addEventListener('reset', this.onFormReset.bind(this)));
            this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
        }
        setupTabEventListeners() {
            const tabInputs = document.querySelectorAll('input[name="tab"]');
            tabInputs.forEach((input) => {
                input.addEventListener('change', this.onTabChange.bind(this));
            });
        }
        onTabChange() {
            this.onChange();
        }
        getActiveTab() {
            const checkedTab = document.querySelector('input[name="tab"]:checked');
            if (!checkedTab)
                return null;
            return checkedTab.value === 'products' ? 'product' : 'article';
        }
        onFormReset(event) {
            super.onFormReset(event);
            if (super.shouldResetForm()) {
                this.keepInSync('', this.input);
            }
        }
        onInput(event) {
            const target = event.target;
            this.keepInSync(target.value, target);
        }
        onInputFocus() {
            const isSmallScreen = window.innerWidth < 750;
            if (isSmallScreen) {
                this.scrollIntoView({ behavior: 'smooth' });
            }
        }
        keepInSync(value, target) {
            this.allSearchInputs.forEach((input) => {
                if (input !== target) {
                    input.value = value;
                }
            });
        }
        updateResults(html) {
            const newResultsWrapper = html.querySelector('.template-search__results-wrapper');
            if (!newResultsWrapper || !this.searchResultsWrapper)
                return;
            this.searchResultsWrapper.innerHTML = newResultsWrapper.innerHTML;
            this.updateDOMCounts();
            this.setupTabEventListeners();
        }
        updateDOMCounts() {
            if (this.lastProductCount === 0 && this.lastArticleCount === 0)
                return;
            const productCount = this.lastProductCount;
            const articleCount = this.lastArticleCount;
            const totalCount = productCount + articleCount;
            // Update product label by replacing the count in brackets
            const productLabel = document.querySelector('label[for="products"]');
            if (productLabel) {
                const currentText = productLabel.textContent || '';
                const updatedText = currentText.replace(/\(\d+\)/, `(${productCount})`);
                productLabel.textContent = updatedText;
            }
            // Update article label by replacing the count in brackets
            const articleLabel = document.querySelector('label[for="articles"]');
            if (articleLabel) {
                const currentText = articleLabel.textContent || '';
                const updatedText = currentText.replace(/\(\d+\)/, `(${articleCount})`);
                articleLabel.textContent = updatedText;
            }
            const productCountDesktop = document.querySelector('#ProductCountDesktop');
            if (productCountDesktop && this.input?.value) {
                productCountDesktop.textContent = `${totalCount} results for "${this.input.value}"`;
            }
            const productTab = document.querySelector('input[value="products"]');
            const articleTab = document.querySelector('input[value="articles"]');
            if (productTab) {
                productTab.disabled = productCount === 0;
                if (productCount > 0 && articleCount === 0) {
                    productTab.checked = true;
                }
            }
            if (articleTab) {
                articleTab.disabled = articleCount === 0;
                if (articleCount > 0 && productCount === 0) {
                    articleTab.checked = true;
                }
            }
            const tabsContainer = document.querySelector('.template-search__results-tabs-container');
            if (tabsContainer) {
                if (productCount > 0 && articleCount === 0) {
                    tabsContainer.setAttribute('data-selected', 'products');
                }
                else if (articleCount > 0 && productCount === 0) {
                    tabsContainer.setAttribute('data-selected', 'articles');
                }
                else if (productCount > 0) {
                    tabsContainer.setAttribute('data-selected', 'products');
                }
            }
        }
        updateURL(newURL) {
            window.history.replaceState({}, '', newURL);
        }
        performSearch(searchUrl, signal) {
            fetch(searchUrl, {
                method: 'GET',
                headers: {
                    Accept: 'text/html',
                },
                signal,
            })
                .then((response) => {
                if (!response.ok) {
                    throw new Error(`Search request failed: ${response.status}`);
                }
                return response.text();
            })
                .then((htmlString) => {
                const html = new DOMParser().parseFromString(htmlString, 'text/html');
                this.updateResults(html);
                this.updateURL(searchUrl);
            })
                .catch((err) => {
                if (err.name !== 'AbortError') {
                    console.error('Search error:', err);
                }
            });
        }
        async fetchResultsCount() {
            const query = this.input?.value || '';
            const graphqlQuery = `
					query SearchResultsCount($query: String!) {
						products: search(query: $query, first: 1, prefix: LAST, types: PRODUCT) {
							totalCount
						}
						articles: search(query: $query, first: 1, prefix: LAST, types: ARTICLE) {
							totalCount
						}
					}
				`.trim();
            fetch('api/2025-07/graphql.json', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    query: graphqlQuery,
                    variables: { query },
                }),
            })
                .then((response) => {
                if (!response.ok) {
                    throw new Error(`GraphQL request failed: ${response.status}`);
                }
                return response.json();
            })
                .then((data) => {
                const productCount = data.data.products?.totalCount || 0;
                const articleCount = data.data.articles?.totalCount || 0;
                this.lastProductCount = productCount;
                this.lastArticleCount = articleCount;
                this.updateDOMCounts();
            })
                .catch((error) => {
                console.error('Error fetching results count:', error);
            });
        }
        onChange() {
            super.onChange();
            this.searchAbortController.abort();
            this.searchAbortController = new AbortController();
            const { signal } = this.searchAbortController;
            if (!this.searchForm)
                return;
            const formData = new FormData(this.searchForm);
            const newParams = new URLSearchParams();
            for (const [key, value] of formData.entries()) {
                if (typeof value === 'string') {
                    newParams.set(key, value);
                }
            }
            const params = new URLSearchParams(window.location.search);
            params.delete('q');
            params.delete('type');
            const activeTab = this.getActiveTab();
            // If articles tab is selected, remove all filter parameters
            if (activeTab === 'article') {
                // Only keep non-filter parameters
                for (const [key, value] of params.entries()) {
                    // Remove any filter parameters (those starting with 'filter.')
                    if (!key.startsWith('filter.')) {
                        newParams.set(key, value);
                    }
                }
            }
            else {
                // For products tab, keep all existing parameters
                for (const [key, value] of params.entries()) {
                    newParams.set(key, value);
                }
            }
            if (activeTab) {
                newParams.set('type', activeTab);
            }
            else {
                newParams.set('type', 'product');
            }
            const searchUrl = `${this.searchForm.action}?${newParams.toString()}`;
            this.fetchResultsCount();
            this.performSearch(searchUrl, signal);
        }
        extractCountFromLabel(labelSelector) {
            const label = document.querySelector(labelSelector);
            if (!label)
                return 0;
            const text = label.textContent || '';
            const match = text.match(/\((\d+)\)/);
            return match ? parseInt(match[1], 10) : 0;
        }
    });
}
